module.exports = __webpack_public_path__ + "static/media/interns.3e9701f4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/interns.webp
// module id = 558
// module chunks = 4